import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { nav } from "../mock";
import { Button } from "./ui/button";
import Wordmark from "./Wordmark";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? "bg-black/95 backdrop-blur border-b border-white/10" : "bg-transparent"
        }`}
    >
      <div className="max-w-[1320px] mx-auto px-5 sm:px-6 lg:px-10 h-[78px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <Wordmark size="sm" variant="light" layout="horizontal" className="group-hover:opacity-90 transition-opacity" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) =>
                `relative text-[14px] font-medium tracking-wide transition-colors ${isActive ? "text-white" : "text-white/75 hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <span className={`pb-1 border-b-2 ${isActive ? "border-[#ff243d]" : "border-transparent"}`}>
                  {n.label}
                </span>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link to="/registration">
            <Button className="bg-[#ff243d] hover:bg-[#e01a32] text-white rounded-full px-5 h-10 font-medium">
              Register Interest
            </Button>
          </Link>
          <Link to="/nominate-to-speak">
            <Button variant="outline" className="rounded-full px-5 h-10 border-white/40 bg-transparent text-white hover:bg-white hover:text-black">
              Speaker Nomination
            </Button>
          </Link>
          <Link to="/sponsors">
            <Button variant="outline" className="rounded-full px-5 h-10 border-white/40 bg-transparent text-white hover:bg-white hover:text-black">
              Partnership Opportunities
            </Button>
          </Link>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-white/10">
          <div className="px-6 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className="text-white py-2 text-base border-b border-white/10"
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/registration">
              <Button className="w-full bg-[#ff243d] hover:bg-[#e01a32] text-white rounded-full mt-2">Register Interest</Button>
            </Link>
            <Link to="/nominate-to-speak">
              <Button variant="outline" className="w-full rounded-full border-white/40 bg-transparent text-white hover:bg-white hover:text-black">Speaker Nomination</Button>
            </Link>
            <Link to="/sponsors">
              <Button variant="outline" className="w-full rounded-full border-white/40 bg-transparent text-white hover:bg-white hover:text-black">Partnership Opportunities</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
